import { render, staticRenderFns } from "./ShooterList.vue?vue&type=template&id=831aa5f2&scoped=true"
import script from "./ShooterList.vue?vue&type=script&lang=js"
export * from "./ShooterList.vue?vue&type=script&lang=js"
import style0 from "./ShooterList.vue?vue&type=style&index=0&id=831aa5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831aa5f2",
  null
  
)

export default component.exports